import RadioImages from './RadioImages'
import RadioNumbers from './RadioNumbers'
import RadioTexts from './RadioTexts'
import CheckboxTexts from './CheckboxTexts'

export default {
  RadioImages,
  RadioNumbers,
  RadioTexts,
  CheckboxTexts,
}
